import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuth";

import Home from "@/pages/Home";
import EventsList from "@/pages/EventsList";
import EventDetail from "@/pages/EventDetail";
import TicketPage from "@/pages/TicketPage";
import Contact from "@/pages/Contact";
import ForVenues from "@/pages/ForVenues";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#A3A3A3]">
        <span className="font-mono-overline">Authenticating…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.title = "Swingle — The UK dating app for lifestylers";
  }, []);

  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/social-events" element={<EventsList type="social" />} />
            <Route path="/spicy-events" element={<EventsList type="spicy" />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/for-venues" element={<ForVenues />} />
            <Route path="/events" element={<Navigate to="/social-events" replace />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/ticket/:id" element={<TicketPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111111",
              border: "1px solid #e2a9f1",
              color: "#EDEDED",
              borderRadius: "2px",
            },
          }}
        />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
